// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SXpZ4","badges":"styles_badges__qvkub"};